export default "<app-landing-screen></app-landing-screen>"